import { useEffect } from 'react';

export default function Favicon() {
  useEffect(() => {
    const favicon = document.createElement('link');
    favicon.rel = 'icon';
    favicon.href = `/private-area/pokerstars_favicon.svg`;
    document.head.appendChild(favicon);

    document.getElementsByTagName('head')[0].appendChild(favicon);
  }, []);

  return null;
}
